/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SettingRow.vue?vue&type=template&id=738bb411&scoped=true&"
import script from "./SettingRow.vue?vue&type=script&setup=true&lang=js&"
export * from "./SettingRow.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SettingRow.vue?vue&type=style&index=0&id=738bb411&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738bb411",
  null
  
)

export default component.exports